import { createClient } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserRepository from "../../repository/UserRepository";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function LoginRedirectPage() {

    const [loadingText, setLoadingText] = useState(null)
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()


    useEffect(() => {        
        async function exchangeGoogleIdTokenWithAuthCode(authCode) {
            console.log("authCode", authCode)
            const userRepository = new UserRepository()
            const response = await userRepository.exchangeGoogleIdTokenWithAuthCode(
                authCode,
                `${window.location.protocol + "//" + window.location.host}/login/redirect`
            )
            console.log(response)

            const { data, error } = await supabase.auth.signInWithIdToken({
                provider: "google",
                token: response.idToken
            });

            console.log("data", data)
            console.log("error", error)

            if (error) {
                console.log("error", error)
                return
            }
            try {
                await userRepository.getUserProfile()
                navigate("/dashboard", {replace: true})
            } catch(e) {
                console.log(`get user profile error ${e.response.status}`)
                if (e.response.status == 404) {
                    navigate("/profile/complete", {replace: true})
                } else {
                    navigate("/login", {replace: true})
                }
                return
            }
        }

        setLoadingText("Verifying login ...")
        exchangeGoogleIdTokenWithAuthCode(searchParams.get("code"))
  
      }, [])

    return (
        <div className="bg-base-200 h-full flex flex-col">
        <div className="navbar px-4">
            <div className="flex-1">
                <img className="h-12" src="https://oesctluxvegwtcqckcdg.supabase.co/storage/v1/object/public/zipmap-resources/full-logo-lightning-light.png"/>
                <div className="text-xl font-bold px-2"></div>
            </div>
        </div>
              {loadingText &&
                <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center pt-4'>
                    <div className="loading loading-infinity loading-lg"></div>
                    <div className='font-normal text-base-content mt-2'>{loadingText}</div>
                </div>
                }
        </div>
    )
}
